import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { useFormContext, useWatch } from 'react-hook-form';
import { OptionsManager } from './OptionsManager';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckboxInput } from '@/shared';

export const OptionsBasedQuestionParameters = ({
  questionIndex,
}: {
  questionIndex: number;
}) => {
  const { t } = useTranslation();
  const form = useFormContext<QuestionnaireFormData>();

  const questionType = useWatch({
    control: form.control,
    name: `questions.${questionIndex}.parameters.type`,
  });
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <OptionsManager
        questionIndex={questionIndex}
        isDisabled={form.formState.isSubmitting}
      />

      {questionType === 'select' && (
        <CheckboxInput
          // @ts-expect-error - I don't know why this is not working
          form={form}
          name={`questions.${questionIndex}.parameters.allowMultiple`}
          label={t('pages.studies.questions.options.allowMultiple')}
        />
      )}
    </Box>
  );
};
